<template>
  <div>
    <label
      class="block text-xs mb-2"
      :for="id"
      v-text="label"
    />
    <input
      :id="id"
      v-model="localValue"
      :class="{ 'error': !!error }"
      :type="type"
      :placeholder="label"
      :autocomplete="type !== 'password'"
    >
    <span
      v-if="!!error"
      class="help-block"
      v-text="error"
    />
  </div>
</template>

<script type="text/babel">
export default {
  name: 'ProfileField',
  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    value: {
      type: String,
      required: true,
    },
    error: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
